// extracted by mini-css-extract-plugin
module.exports = {"item":"CategoryItem_item__jqNZm","title":"CategoryItem_title__bIYa7","description":"CategoryItem_description__Bh1kr"};